import { WidgetDefinition } from "@insite/client-framework/Types/ContentItemDefinitions";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Typography from "@insite/mobius/Typography";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import UCSColors from "@ucs/Utils/UCSColors";
import React from "react";
import styled, { css } from "styled-components";

const enum fields {
    title = "title",
    subtitle = "subtitle",
    icon = "icon",
    linkText = "linkText",
    linkUrl = "linkUrl"
}

const SocialMediaPromoContainer = styled.div`
    display: flex;
    padding: 45px;
    flex-direction: column;

    ${({ theme }) =>
        breakpointMediaQueries(theme, [
            css`
                padding: 20px;
            `,
            css`
                padding: 20px;
            `
        ])};

    h5 {
        font-size: 15px !important;
    }
`;

const SocialMediaPromoFooter = styled.div`
    display: flex;
    ${({ theme }) =>
        breakpointMediaQueries(theme, [
            css`
                flex-direction: column;
            `,
            css`
                flex-direction: column;
            `
        ])};
`;

const SocialMediaPromoFooterLeft = styled.div`
    flex-basis: 50%;
    ${({ theme }) =>
        breakpointMediaQueries(theme, [
            css`
                flex-basis: 100%;
                margin-bottom: 16px;
            `,
            css`
                flex-basis: 100%;
                margin-bottom: 16px;
            `
        ])};
`;

const SocialMediaPromoFooterRight = styled.div`
    flex-basis: 50%;
    ${({ theme }) =>
        breakpointMediaQueries(theme, [
            css`
                flex-basis: 100%;
            `,
            css`
                flex-basis: 100%;
            `
        ])};
`;

const Icon = styled.img`
    height: 18px;
    max-width: 18px;
    margin-right: 12px;
`;

const Link = styled.a`
    height: 18px;
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    flex-direction: row;
    justify-content: flex-end;
    ${({ theme }) =>
        breakpointMediaQueries(theme, [
            css`
                justify-content: flex-start;
            `,
            css`
                justify-content: flex-start;
            `
        ])};
`;


const SocialMediaPromo: React.FC<WidgetProps> = props => {
    const title = props.fields.title;
    const subtitle = props.fields.subtitle;
    const icon = props.fields.icon;
    const linkText = props.fields.linkText;
    const linkUrl = props.fields.linkUrl;

    const [showInstagram, setShowInstagram] = React.useState(true);

    React.useEffect(() => {
        if ( document?.getElementById('tintup_widget')?.innerHTML === "") {
            setShowInstagram(false);
        }
    }, []);

    return ( <>{showInstagram && <SocialMediaPromoContainer>
        <Typography variant="h2" as="h2" size={36}>
            {title}
        </Typography>
        <SocialMediaPromoFooter>
                <SocialMediaPromoFooterLeft>
                    <Typography variant="h5" as="h5" size={15} color={UCSColors.gray04}>{subtitle}</Typography>
                </SocialMediaPromoFooterLeft>
                <SocialMediaPromoFooterRight>
                    <Link href={linkUrl} target="_blank"><Icon src={icon} />
                        <Typography size={20} color={UCSColors.gray04}>{linkText}</Typography>
                    </Link>
                </SocialMediaPromoFooterRight>
            </SocialMediaPromoFooter>
    </SocialMediaPromoContainer>}</>
    );
}

const definition: WidgetDefinition = {
    group: "Basic",
    fieldDefinitions: [
        {
            name: fields.title,
            displayName: "Title",
            defaultValue: "",
            editorTemplate: "TextField",
            fieldType: "General",
        },
        {
            name: fields.subtitle,
            displayName: "Subtitle",
            defaultValue: "",
            editorTemplate: "TextField",
            fieldType: "General",
        },
        {
            name: fields.icon,
            displayName: "Icon",
            editorTemplate: "ImagePickerField",
            defaultValue: "",
            fieldType: "General",
        },
        {
            name: fields.linkText,
            displayName: "Link Text",
            editorTemplate: "TextField",
            defaultValue: "",
            fieldType: "General"
        },
        {
            name: fields.linkUrl,
            displayName: "Link URL",
            editorTemplate: "TextField",
            defaultValue: "",
            fieldType: "General"
        }  
    ],
};

const widgetModule: WidgetModule = {
    component: SocialMediaPromo,
    definition,
};

export default widgetModule;